import { createContext, useContext } from 'react';
import type { AuthMode } from '@/config';

export interface AuthUser {
  email: string;
  /** Display name (dev bypass: VITE_DEV_USER; Supabase: user metadata, else the email). */
  name: string;
}

export interface AuthState {
  mode: AuthMode;
  /** True until the first session check finishes. */
  loading: boolean;
  user: AuthUser | null;
  /** Emails a one-time code (and a link); resolves once the email is on its way. */
  signInWithEmail: (email: string, next?: string) => Promise<void>;
  /** Exchanges the emailed code for a session; works on any device, unlike the link. */
  verifyEmailCode: (email: string, code: string) => Promise<void>;
  signOut: () => Promise<void>;
  /** Last auth error (e.g. a broken or expired link), for the login and callback pages. */
  error: string | null;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}
